import { useUIThemeContext } from "@pathwright/ui/src/components/ui/PathwrightUI"
import { getFilestackBrandIconUrl } from "@pathwright/ux/src/components/filestack/api"
import { useEffect, useState } from "react"
import { createGlobalStyle } from "styled-components"
import { usePathwrightContext } from "./PathwrightContext"
import "./legacy-reset-styles.css"

const useViewportHeight = () => {
  const [viewportHeight, setViewportHeight] = useState<number>()

  useEffect(() => {
    const handleResize = () => setViewportHeight(window.innerHeight)
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  })

  return viewportHeight
}

export const SchoolGlobalThemeStyles = createGlobalStyle<{
  $scope: string
  $theme: {
    primary_color: string
    heading_font?: string | null
    filestack_brand_icon?: string
  }
}>`
  :root ${(props) => props.$scope} {
    --school-main-color: ${(props) => props.$theme.primary_color};
    --school-heading-font: ${(props) => props.$theme.heading_font};
    --filestack-brand-icon: ${(props) => props.$theme.filestack_brand_icon};
  }

  #root ${(props) => props.$scope}, .chakra-portal ${(props) => props.$scope} {
    .theme-heading {
      font-family: var(--school-heading-font), "ProximaNova-Regular", Helvetica,
        sans-serif;
      font-optical-sizing: auto;
      font-weight: 400;
      font-style: normal;
    }

    .theme-heading.theme-heading-regular {
      font-weight: 400;
    }

    .theme-heading.theme-heading-bold {
      font-weight: 700;
    }

    .theme-heading.theme-heading-semibold {
      font-weight: 600;
    }
  }

  /*
    Hide loading splash once client is loaded.
    This ensures these items won't be seen on devices when scrolling top UI when at the top or bottom of the screen.
  */
  .loading-splash {
    opacity: 0 !important;
  }
`

export function GlobalThemeStyles() {
  const { school } = usePathwrightContext()
  const primaryColor = school.theme?.primary_color
    ? `#${school.theme?.primary_color}`
    : "#0d71fb"

  return (
    <SchoolGlobalThemeStyles
      $scope="" /* Global scope */
      $theme={{
        primary_color: primaryColor,
        heading_font: school.theme?.heading_font,
        filestack_brand_icon: getFilestackBrandIconUrl(primaryColor)
      }}
    />
  )
}

// TODO: assess whehter we still need the viewport height variable.
const LegacyGlobalSchoolThemeStyles = createGlobalStyle<{
  $viewportHeight: number | undefined
}>`
  :root {
    --vh: ${(props) => props.$viewportHeight}px;
  }

  /*
    Hide loading splash once client is loaded.
    This ensures these items won't be seen on devices when scrolling top UI when at the top or bottom of the screen.
    Must stay in a global style (not static CSS) so it only applies once mounted.
  */
  .loading-splash {
    opacity: 1;
  }
  .loading-splash-info,
  .loading-splash-spinner {
    opacity: 0;
    transition: opacity 0.5s;
  }
`

export default () => {
  const theme = useUIThemeContext()
  const viewportHeight = useViewportHeight()
  return (
    <>
      <GlobalThemeStyles />
      <LegacyGlobalSchoolThemeStyles $viewportHeight={viewportHeight} />
    </>
  )
}
